import { render, staticRenderFns } from "./section-component.mobile.vue?vue&type=template&id=e99ec892&scoped=true&"
import script from "./section-component.mobile.vue?vue&type=script&lang=ts&"
export * from "./section-component.mobile.vue?vue&type=script&lang=ts&"
import style0 from "./section-component.mobile.vue?vue&type=style&index=0&id=e99ec892&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99ec892",
  null
  
)

export default component.exports